// Plan-based restrictions configuration
export const PLAN_LIMITS = {
  FREE: {
    cardLimit: 100,
    speeds: ['slow'],
    apis: {
      shopii: ['#3', '#4'],
      paypal: [],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: ['Shopii #1', 'Shopii #2', 'PayPal AVS', 'PayPal Mass']
  },
  Bronze: {
    cardLimit: 500,
    speeds: ['slow', 'normal'],
    apis: {
      shopii: ['#1', '#2', '#3', '#4'],
      paypal: ['all'],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: []
  },
  Silver: {
    cardLimit: 1500,
    speeds: ['slow', 'normal'],
    apis: {
      shopii: ['#1', '#2', '#3', '#4'],
      paypal: ['all'],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: []
  },
  Gold: {
    cardLimit: 2500,
    speeds: ['slow', 'normal', 'fast'],
    apis: {
      shopii: ['#1', '#2', '#3', '#4'],
      paypal: ['all'],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: []
  },
  Diamond: {
    cardLimit: 4000,
    speeds: ['slow', 'normal', 'fast', 'turbo'],
    apis: {
      shopii: ['#1', '#2', '#3', '#4'],
      paypal: ['all'],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: []
  },
  PREMIUM: {
    // Generic PREMIUM - treat as Bronze
    cardLimit: 500,
    speeds: ['slow', 'normal'],
    apis: {
      shopii: ['#1', '#2', '#3', '#4'],
      paypal: ['all'],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: []
  },
  ADMIN: {
    cardLimit: 10000,
    speeds: ['slow', 'normal', 'fast', 'turbo', 'instant'],
    apis: {
      shopii: ['#1', '#2', '#3', '#4'],
      paypal: ['all'],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: []
  },
  OWNER: {
    cardLimit: 100000,
    speeds: ['slow', 'normal', 'fast', 'turbo', 'instant'],
    apis: {
      shopii: ['#1', '#2', '#3', '#4'],
      paypal: ['all'],
      stripeAuth: ['v1', 'v2', 'v3'],
      stripeSK: ['all']
    },
    lockedAPIs: []
  }
};

export const getPlanLimits = (userPlan, userStatus) => {
  // Priority logic:
  // 1. OWNER/ADMIN status -> unlimited access
  // 2. Specific plan (Gold, Diamond, Bronze, Silver) -> use plan limits
  // 3. Generic status (PREMIUM, FREE) -> use status limits
  
  // Check for OWNER/ADMIN first (unlimited access)
  if (userStatus === 'OWNER' || userStatus === 'ADMIN') {
    return PLAN_LIMITS[userStatus];
  }
  
  // Check for specific plans (Gold, Diamond, Bronze, Silver)
  if (userPlan && PLAN_LIMITS[userPlan] && !['PREMIUM', 'FREE'].includes(userPlan)) {
    return PLAN_LIMITS[userPlan];
  }
  
  // Fall back to status or FREE
  const effectivePlan = userStatus || userPlan || 'FREE';
  return PLAN_LIMITS[effectivePlan] || PLAN_LIMITS.FREE;
};

export const isSpeedAllowed = (userPlan, userStatus, speed) => {
  const limits = getPlanLimits(userPlan, userStatus);
  return limits.speeds.includes(speed);
};

export const isAPILocked = (userPlan, userStatus, apiName) => {
  const limits = getPlanLimits(userPlan, userStatus);
  return limits.lockedAPIs.some(locked => apiName.includes(locked));
};

export const getCardLimit = (userPlan, userStatus) => {
  const limits = getPlanLimits(userPlan, userStatus);
  return limits.cardLimit;
};

export const getSpeedOptions = (userPlan, userStatus) => {
  const limits = getPlanLimits(userPlan, userStatus);
  const allSpeeds = [
    { value: 'slow', label: 'Slow' },
    { value: 'normal', label: 'Normal' },
    { value: 'fast', label: 'Fast' },
    { value: 'instant', label: 'Instant' }
  ];
  
  return allSpeeds.map(speed => ({
    ...speed,
    disabled: !limits.speeds.includes(speed.value)
  }));
};
